export enum PractitionersEndpointsEnum {
  PRACTITIONERS = "/practitioners",
}
